export const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY;

export const POSTHOG_OPTIONS = {
  api_host: import.meta.env.VITE_POSTHOG_HOST ?? 'https://us.i.posthog.com',
  defaults: '2026-05-30' as any,
  // Super App and box-os share one PostHog project (so backend error correlation
  // works across both) but only box-os wants the feedback widget/survey UI.
  disable_surveys: true,
};
